import { useContext } from "react";
import { AlertContext } from "contexts/alert/alert-provider";

export const useAlert = () => useContext(AlertContext);
